import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { useGlobalHotkeyDialogTrigger } from '../utils/document-keydown.hook';
import { Board } from './board';

export const TicTacToe = () => {
  const { open, setOpen } = useGlobalHotkeyDialogTrigger({ key: 'k', cmd: true, shift: true });

  return (
    <div>
      <Transition appear show={open} as={Fragment}>
        <Dialog
          as='div'
          className='tic-tac-toe'
          onClose={() => {
            setOpen(false);
          }}
        >
          <div className='fixed inset-0 overflow-y-auto flex items-center justify-center z-neue-cmdk'>
            <div className='flex h-auto w-[440px] h-auto items-start justify-center p-4'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full max-h-full bg-neue-journey-bg-90 rounded-lg max-w-xl flex flex-col items-center overflow-hidden'>
                  <div className='flex-1 focus:outline-none flex' tabIndex={-1}>
                    <Board />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};
